import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { AppNotification } from '@app/helpers';
import { AuthService, LocalStorageService } from '@app/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export  class LoginComponent implements OnInit,OnDestroy {

  loginForm : FormGroup = new FormGroup({});
  redirectTo: string | null;
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}  

  ngOnInit():void {
    this.redirectTo = this.route.snapshot.queryParamMap.get('redirect')
    console.log('login component called')
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required])
    });
  }

  submitLoginForm(){
    console.log('sumbit form',this.loginForm?.value)
    this.authService.login(this.loginForm?.value.email, this.loginForm?.value.password).subscribe({
      next: (res: any)=>{
        LocalStorageService.setSession(res.data)
        if(this.redirectTo) {
          this.router.navigateByUrl(this.redirectTo)
          return;
        } 
        this.router.navigate([APP_ROUTES.HOME]);
      },
      error: (error) => {
        AppNotification.error('Username or password incorrect!')
      }
    })
  }

  ngOnDestroy(): void {
    
  }

}
